/** This model can be used to inject properties into FeatureInfoSections context. These properties will be accessible from featureInfoTemplate mustache template.
 */
let FeatureInfoContext;
(function (_FeatureInfoContext) {
  function is(model) {
    return "featureInfoContext" in model;
  }
  _FeatureInfoContext.is = is;
})(FeatureInfoContext || (FeatureInfoContext = {}));
export default FeatureInfoContext;